export default "__VITE_ASSET__a41cd0e9__"